import { getStorage, ref, uploadBytes, getDownloadURL } from "firebase/storage";

class FirebaseUploadAdapter {
  private loader: any;
  private storage = getStorage();

  constructor(loader: any) {
    this.loader = loader;
  }

  async upload() {
    const file = await this.loader.file;
    if (!file) throw new Error("No file to upload");

    // create a unique path in Firebase Storage
    const storageRef = ref(this.storage, `uploads/${Date.now()}_${file.name}`);

    // upload file
    await uploadBytes(storageRef, file);

    // get download URL
    const downloadURL = await getDownloadURL(storageRef);

    // return CKEditor expected format
    return {
      default: downloadURL,
    };
  }

  abort() {
    // Handle cancel if needed
  }
}

export default FirebaseUploadAdapter;